import { createContext } from 'react';
import { PwaInstallationContextValue } from './types';

export const PwaInstallationContext = createContext<PwaInstallationContextValue | null>(null);